import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Role } from '../data/types';
import { Users, Briefcase, ShieldCheck, Activity } from 'lucide-react';
import { motion } from 'framer-motion';
import clsx from 'clsx';
export function LoginPage() {
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState<Role | null>(null);
  const handleLogin = (role: Role) => {
    login(role);
    // Redirect based on role
    if (role === 'employee') navigate('/employee');else if (role === 'hr') navigate('/hr/dashboard');else if (role === 'management') navigate('/mgmt/dashboard');else if (role === 'admin') navigate('/admin/kb');
  };
  const roles = [{
    id: 'employee',
    label: 'Employee',
    icon: Users,
    desc: 'Anonymous feedback & Q/A'
  }, {
    id: 'hr',
    label: 'HR Admin',
    icon: Activity,
    desc: 'Analyze trends & insights'
  }, {
    id: 'management',
    label: 'Management',
    icon: Briefcase,
    desc: 'Strategic overview'
  }, {
    id: 'admin',
    label: 'System Admin',
    icon: ShieldCheck,
    desc: 'Configure platform'
  }];
  return <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4 relative overflow-hidden" data-id="element-296">
      {/* Cinematic Background */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-surfaceHighlight via-background to-background opacity-50" data-id="element-297" />
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-accent/5 rounded-full blur-[100px]" data-id="element-298" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="relative z-10 text-center mb-12" data-id="element-299">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-accent mb-6 shadow-2xl shadow-accent/20" data-id="element-300">
          <Activity className="w-8 h-8 text-background" data-id="element-301" />
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 tracking-tight" data-id="element-302">
          CoolerPulse
        </h1>
        <p className="text-xl text-secondary max-w-md mx-auto" data-id="element-303">
          AI-Powered Organizational Health Platform
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl w-full relative z-10" data-id="element-304">
        {roles.map((role, idx) => <motion.button key={role.id} initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: idx * 0.1
      }} onClick={() => handleLogin(role.id as Role)} className="glass-card p-6 rounded-xl text-left hover:bg-white/5 transition-all group border border-white/5 hover:border-accent/30" data-id="element-305">
            <div className="flex items-center space-x-4" data-id="element-306">
              <div className="p-3 rounded-lg bg-surface group-hover:bg-accent group-hover:text-background transition-colors text-accent" data-id="element-307">
                <role.icon className="w-6 h-6" data-id="element-308" />
              </div>
              <div data-id="element-309">
                <h3 className="text-lg font-semibold text-white group-hover:text-accent transition-colors" data-id="element-310">
                  {role.label}
                </h3>
                <p className="text-sm text-secondary" data-id="element-311">{role.desc}</p>
              </div>
            </div>
          </motion.button>)}
      </div>

      <footer className="mt-16 text-secondary text-sm relative z-10" data-id="element-312">
        <p data-id="element-313">© 2024 CoolerPulse AI. All rights reserved.</p>
      </footer>
    </div>;
}